import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import {
  createSignupGenerator,
  deleteSignupGenerator,
} from 'redux/signup-generator/actions';

import { Checkbox } from 'semantic-ui-react';

import './SignupGeneratorSwitcher.css';


const SignupGeneratorSwitcher = ({
  me,
  createSignupGenerator,
  deleteSignupGenerator,
}) => {
  const { t } = useTranslation();

  if (!me) return null;

  const checkboxChange = (_e, { checked }) => {
    if (checked) {
      createSignupGenerator();
    } else {
      deleteSignupGenerator(me.signup_generator);
    }
  };

  return (
    <div className="email-signup-generator-switcher__component">
      <div className="email-signup-generator-switcher-wrapper">
        <div className="email-signup-generator-text-section">

          <div className="text-item">
            <h4>{t("Email Signup")}</h4>
          </div>
          <p>
            {t("Add an Email Signup form to your HeyLink.me so your visitors can easily signup!")}
          </p>
        </div>
        <div className="switcher-wrapper">
          <span>{t("OFF")}</span>
          <Checkbox
            toggle
            checked={me && Boolean(me.signup_generator)}
            onChange={checkboxChange}
          />
          <span>{t("ON")}</span>
        </div>
      </div>
    </div>
  );
};

SignupGeneratorSwitcher.propTypes = {
  me: PropTypes.object,
  createSignupGenerator: PropTypes.func,
  deleteSignupGenerator: PropTypes.func,
};
SignupGeneratorSwitcher.defaultProps = {
  me: null,
  createSignupGenerator: null,
  deleteSignupGenerator: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    createSignupGenerator,
    deleteSignupGenerator,
  },
)(SignupGeneratorSwitcher);
